import React, {PropTypes} from 'react'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import {eq} from 'lodash/lang'
import styles from './b2bCompany.scss'
import NoResults from '../noResults'
import TooManyResults from '../tooManyResults'
import underscore from 'underscore'

import i18n from 'lib/i18n'
const _ = i18n('clients')

export default	class B2bCompanyClientResults extends React.Component {
	static propTypes = {
		data: PropTypes.array
	}
	shouldComponentUpdate(nextProps) {
		return !eq(this.props.data, nextProps.data)
	}
	// handleSelectChangeState(stateList) {
	// 	this.setState({stateList})
	// }
	render() {
		const {data, zoomTo} = this.props
		// const {stateOptions} = this.props
		// const {stateList} = this.state
		return (
			<div className={styles.clientsTableContainer}>
				{ data && underscore.isArray(data) && (data[0] !== 'Too many rows') &&
					<Table
						className={styles.table}
						itemsPerPage={10}
						filterable={[
							/*"policy",
							"society",
							"security",
							"risk",
							"state",
							"end",
							"policyholder",*/
							"name",
							"address",
							"email",
							"phoneNumber",
							"clientNumber",
						]}
						sortable={[
							/*"policy",
							"society",
							"security",
							"risk",
							"state",
							"end",
							"policyholder",*/
							"name",
							"address",
							"email",
							"phoneNumber",
							"clientNumber",
						]}
						defaultSort={{
							column: 'policy',
							direction: 'desc',
						}}
					>
						<Thead>
							{/*<Th column="policy">
								<strong>{_('policy')}</strong>
							</Th>
							<Th column="society">
								<strong>{_('society')}</strong>
							</Th>
							<Th column="security">
								<strong>{_('security')}</strong>
							</Th>
							<Th column="risk">
								<strong>{_('risk')}</strong>
							</Th>
							<Th column="state">
								<strong>{_('state')}</strong>
							</Th>
							<Th column="end">
								<strong>{_('end')}</strong>
							</Th>
							<Th column="policyholder">
								<strong>{_('policyholder')}</strong>
							</Th>*/}
							<Th column="name">
								<strong>{_('name')}</strong>
							</Th>
							<Th column="clientNumber">
								<strong>{_('clientNumber')}</strong>
							</Th>
							<Th column="address">
								<strong>{_('clientAddress')}</strong>
							</Th>
							<Th column="phoneNumber">
								<strong>{_('phoneNumber')}</strong>
							</Th>
							<Th column="email">
								<strong>{_('email')}</strong>
							</Th>
						</Thead>
						{ data.map((item, key) =>
							<Tr
								className="clickable centered"
								onClick={() => zoomTo(item.clientId)} key={key}
							>
								{/*<Td column="policy">{item.policy}</Td>
								<Td column="society">{item.society}</Td>
								<Td column="security">{item.security}</Td>
								<Td column="risk">{item.security}</Td>
								<Td column="state">									
									<SelectWrap
										options={stateOptions}
										onChange={(e) => this.handleSelectChangeState(e)}
										value={this.state.stateList}
										placeholder={_('selectState')}
										backspaceRemoves={false}
										autoBlur
										multi
										simpleValue
									/>
									{item.security}
								</Td>
								<Td column="end">{item.security}</Td>
								<Td column="policyholder">{item.security}</Td>*/}
								<Td column="name">{item.name}</Td>
								<Td column="clientNumber">{item.clientNumber}</Td>
								<Td column="address">{item.mainAddress}</Td>
								<Td column="email">{item.email}</Td>
								<Td column="phoneNumber">{item.phoneNumber}</Td>
							</Tr>
							)
						}
					</Table>
				}
				{ data && underscore.isArray(data) && data.length === 0 &&
				<NoResults type="clients"/>
				}
				{ data && underscore.isArray(data) && data[0] === 'Too many rows' &&
				<TooManyResults	type="clients"/>
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/b2bCompany/b2bCompanyClientResults.jsx